import React from "react"
import { Link } from "react-router-dom"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { tableStyle, thStyle, tdStyle } from "../styles/commonStyles"
import { getStatusStyle, getStatusTextStyle, snakeToTitleCase } from "../utils/helpers"
import PaymentTypeIndicator from "./PaymentTypeIndicator"

const CustomerTable = ({ customers, customerSchedules = {}, loading, page = 1, limit = 10 }) => {
	const columns = [
		{ key: "no", label: "#" },
		{ key: "id", label: "รหัสสมาชิกนสพ." },
		{ key: "name", label: "ชื่อ / นาม" },
		{ key: "email_msisdn", label: "อีเมล / เบอร์โทรศัพท์" },
		{ key: "latestPlan", label: "แพ็คเกจล่าสุด" },
		// { key: "planCount", label: "จำนวนแพ็ค" },
		{ key: "status", label: "สถานะ" },
		{ key: "expiredAt", label: "วันที่หมดอายุ" },
		{ key: "updatedAt", label: "แก้ไขล่าสุด" },
	]

	return (
		<div style={{ overflowX: "auto" }}>
			<table style={tableStyle}>
				<thead>
					<tr>
						{columns.map((col) => (
							<th key={col.key} style={thStyle}>
								{col.label}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{loading ? (
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center", padding: 24, color: "#888" }}>
								กำลังโหลด...
							</td>
						</tr>
					) : customers.length === 0 ? (
						<tr>
							<td colSpan={columns.length} style={{ textAlign: "center", padding: 24, color: "#888" }}>
								ไม่พบข้อมูลลูกค้า
							</td>
						</tr>
					) : (
						customers.map((c, index) => {
							const globalIndex = (page - 1) * limit + index + 1
							return (
								<tr key={c.id}>
									<td style={tdStyle}>{globalIndex}.</td>
									<td style={tdStyle}>
										<Link to={`detail/${encodeURIComponent(c.id)}`}>{c.id}</Link>
									</td>
									<td style={tdStyle}>
										{c.customerInfo?.name && c.customerInfo.name.length > 35 ? `${c.customerInfo.name.substring(0, 30)}...` : c.customerInfo?.name}
									</td>
									<td style={tdStyle}>{c.user?.email || c.user?.msisdn}</td>
									<td style={tdStyle}>
										{c.latestPlan?.name && (
											<div style={{ display: "flex", alignItems: "center", gap: 4 }}>
												<PaymentTypeIndicator
													isRecurring={c.isRecurring}
													planType={c.latestPlan.type}
													schedule={customerSchedules[c.id]}
													size={14}
													showText={false}
												/>
												{c.latestPlan.name}
											</div>
										)}
									</td>
									{/* <td style={tdStyle}>{c.planCount}</td> */}
									<td style={tdStyle}>
										<span style={getStatusTextStyle(c.enewspaperStatus)}>{snakeToTitleCase(c.enewspaperStatus)}</span>
									</td>
									<td style={tdStyle}>{formatThaiBuddhistDate(c.expiredAt)}</td>
									<td style={tdStyle}>{formatThaiBuddhistDate(c.updatedAt)}</td>
								</tr>
							)
						})
					)}
				</tbody>
			</table>
		</div>
	)
}

export default CustomerTable
